/** Rutas relativas al prefijo `/comercial`. */
export const commercialPaths = {
  clients: 'clientes',
  operations: 'operaciones',
  operationNew: 'operaciones/nueva',
  operationDetail: 'operaciones/:id',
} as const;
